import React, { useState } from "react";
import {
    GcDepartureProspectLevelOfInterest,
    GroupMemberProspectDetailsFragment,
} from "generated/graphql";
import { useI18n } from "@wojo/localization";
import { Text } from "@wojo/ui";
import { useId } from "react";
import { InterestedTravelersTable } from "./InterestedTravelersTable";
import { NoInterestedTravelersInfoCard } from "../no-interested-travelers-info-card/NoInterestedTravelersInfoCard";
import { AddInterestedTravelerForm } from "../add-interested-traveler-form/AddInterestedTravelerForm";
import { orderBy } from "lodash";
import { MarkdownForNextLinks } from "components/markdown-for-next-links";

export type InterestedTravelersProps = {
    gcDepartureProspects: GroupMemberProspectDetailsFragment[];
    groupCoordinatorCustomerId: string;
    gcDepartureId: string;
};

export const InterestedTravelers: React.FC<InterestedTravelersProps> = ({
    gcDepartureProspects,
    groupCoordinatorCustomerId,
    gcDepartureId,
}) => {
    const headingId = useId();
    const i18n = useI18n("account").account.myGroupMembers;
    const [
        isAddInterestedTravelerModalOpen,
        setIsAddInterestedTravelerModalOpen,
    ] = useState(false);

    const interestLevelOrder = {
        [GcDepartureProspectLevelOfInterest.High]: 1,
        [GcDepartureProspectLevelOfInterest.Medium]: 2,
        [GcDepartureProspectLevelOfInterest.Low]: 3,
    };

    return (
        <section
            aria-labelledby={headingId}
            style={{
                paddingTop: "var(--g-spacing-lg)",
                marginBottom: "var(--g-spacing-xl)",
            }}
        >
            <Text.Heading
                id={headingId}
                order="3"
                tag="h2"
                style={{ paddingBottom: "var(--g-spacing-sm)" }}
            >
                {i18n.interestedTravelers.heading.l()}
            </Text.Heading>
            <MarkdownForNextLinks
                style={{
                    paddingBottom: "var(--g-spacing-lg)",
                }}
                markdown={i18n.interestedTravelers.description.l()}
            />
            {gcDepartureProspects.length > 0 ? (
                <InterestedTravelersTable
                    interestedTravelers={orderBy(
                        gcDepartureProspects,
                        [
                            (traveler) =>
                                traveler.levelOfInterest
                                    ? interestLevelOrder[
                                          traveler.levelOfInterest
                                      ]
                                    : 4,
                        ],
                        ["asc"],
                    )}
                    openAddInterestedTravelerModal={() =>
                        setIsAddInterestedTravelerModalOpen(true)
                    }
                />
            ) : (
                <NoInterestedTravelersInfoCard
                    openAddInterestedTravelerModal={() =>
                        setIsAddInterestedTravelerModalOpen(true)
                    }
                />
            )}
            <AddInterestedTravelerForm
                isAddInterestedTravelerModalOpen={
                    isAddInterestedTravelerModalOpen
                }
                onCloseAddInterestedTravelerModal={() =>
                    setIsAddInterestedTravelerModalOpen(false)
                }
                groupCoordinatorCustomerId={groupCoordinatorCustomerId}
                gcDepartureId={gcDepartureId}
            />
        </section>
    );
};
